import { render, staticRenderFns } from "./sisSidebar.vue?vue&type=template&id=220d4a20&scoped=true"
import script from "./sisSidebar.vue?vue&type=script&lang=js"
export * from "./sisSidebar.vue?vue&type=script&lang=js"
import style0 from "./sisSidebar.vue?vue&type=style&index=0&id=220d4a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d4a20",
  null
  
)

export default component.exports